













































import { pickBy } from 'lodash'
import TextComparison from './TextComparison.vue'
import ImageComparison from './ImageComparison.vue'
import LinkComparison from './LinkComparison.vue'
import RadioButtonGroup, { ButtonType } from './RadioButtonGroup.vue'
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import * as db from '@shared/types/database'

@Component({
  components: {
    TextComparison,
    ImageComparison,
    LinkComparison,
    RadioButtonGroup
  }
})
export default class ComparisonList extends Vue {
  @Prop({ default: '' }) readonly comparisonType!: 'text' | 'images' | 'links'
  @Prop({ default: () => ({}) }) readonly comparison!: Record<string, db.Prototype>
  @Prop({ default: () => ({}) }) readonly sharedAssets!: any
  @Prop({ default: true }) readonly editable!: boolean
  @Prop({ default: true }) readonly typeSwitchable!: boolean

  @Watch('comparisonType')
  comparisonTypeUpdated () {
    if (this.editable) {
      this.$emit('resetComparison', {})
    }
  }

  get typeHelperText () {
    switch (this.comparisonType) {
      case 'text':
        return 'E.g. features, messaging, product names, etc.'
      case 'images':
        return 'E.g. single screens, call to actions (CTA’s), icons, etc'
      case 'links':
        return 'E.g. prototypes, websites, etc.'
      default:
        return 'Unsupported comparison type'
    }
  }

  get typeButtons (): ButtonType[] {
    return [
      { title: 'Text', value: 'text' },
      { title: 'Images', value: 'images' },
      { title: 'Links', value: 'links' }
    ]
  }

  get maxItems () {
    switch (this.comparisonType) {
      case 'text':
        return 10
      case 'images':
      case 'links':
      default:
        return 4
    }
  }

  get images () {
    var that = this
    return pickBy(this.sharedAssets, function (value, key) {
      return that.isImage(value)
    })
  }

  get links () {
    var that = this
    return pickBy(this.sharedAssets, function (value, key) {
      return !that.isImage(value)
    })
  }

  created () {
    this.$watch(
      () => this.comparison,
      (newVal, oldVal) => {
        this.$emit('updatecomparison', newVal)
      },
      { deep: true }
    )
  }

  buttonClasses (type: string) {
    return type === this.comparisonType ? 'on' : ''
  }

  isImage (asset: db.Prototype) {
    return ['jpg', 'jpeg', 'gif', 'png', 'tiff'].some(function (ext) {
      return asset.url && asset.url.slice(ext.length * -1) === ext
    })
  }

  addOption () {
    if (Object.keys(this.comparison).length >= this.maxItems) {
      return false
    }
    var newItem = {}
    var ts = +new Date()
    switch (this.comparisonType) {
      case 'links':
        newItem = {
          asset_type: 'url',
          title: '',
          url: ''
        }
        break
      case 'text':
        newItem = {
          asset_type: 'textComparison',
          title: ''
        }
        break
      case 'images':
        break // images cannot be added like this
    }
    // Ensure we're using a new key
    while (this.comparison.hasOwnProperty(ts)) {
      ts++
    }
    this.$set(this.comparison, ts, newItem)
  }

  removeOption (id: string) {
    this.$delete(this.comparison, id)
  }
}
